Vue.asyncComponent('ak-form', {
	props: {
		definition: {
			type: String,
			required: true
		},
		bundle: {
			type: String,
			required: true
		},
		objectId: {
			type: String,
			required: false,
			default: 'new'
		},
		relationString: {
			type: String,
		},
		baseUriControls: {
			type: String,
			required: false,
			default() {
				return this.$appKitUrl() + '/' + this.bundle + '/' + this.definition;
			},
		}
	},
    data() {
        return {
			title: '',
			descr: '',
			form: {},
			baseUri: this.$appKitUrl() + '/' + this.bundle + '/' + this.definition,
			formValues: {},
			widgetGroups: {},
			ungroupedWidgets: [],
			states: {
				visibility: {}
			}
        }
    },
    methods: {
		async getForm(formData) {
			let param = {};

			if(this.objectId != 'new') param.id = this.objectId;

			try {
				let result;

				if (!formData) result = await this.$get(this.baseUri, param);
                else result = formData;

				this.form = result.form;
				this.title = result.title;
				this.descr = result.descr;
				// this.bundle = result.bundle;
			} catch (error) {
				console.log(error);
            }

            this.createWidgetGroups();
		},
        async submit() {
			const url = `${this.baseUri}/post`;
			const body = { "formValues": { ...this.formValues }};
			let param = {};
			if(this.objectId != 'new') param.id = this.objectId;

			try {
				const result = await this.$post(url, body, param);
				if (result.success) this.$handleActions(result.todos, this);
				else this.getForm(result);
				this.$emit('submit');
			} catch (error) {
				console.log(error);
			}
        },
        handleWidgetInput(id, data) {
			this.formValues[id] = data;
			this.applyStates(id);
		},
		widgetAttributes(widget) {
			let attributes = {
				...widget.formControl,
				...widget.attributes,
				id: widget.id,
				baseUri: this.baseUriControls,
				relationString: this.relationString,
				currentObjectId: this.objectId
			};

			if(widget.relation) {
				attributes.relation = widget.relation;
			}

			return attributes;
		},
		widgetListener(id) {
			let out = {};

			// check if we have form syncs for this control
			if(this.form.syncs && this.form.syncs[id]) {
				this.form.syncs[id].forEach(event => {
					// add th sync form function for each listener
					out[event] = this.syncForm.bind(null, id, event);
				});
			}

			return out;
		},
		async syncForm(id, event) {
			const url = `${this.baseUri}/sync`;
			const body = {
				id: id,
				event: event,
				values: this.formValues
			};
			let param = {};

			try {
				const result = await this.$post(url, body, param);
				this.updateFormValues(result);
			} catch (error) {
				console.log(error);
			}
		},
		updateFormValues(newValues) {
			for(let id in newValues) {
				// find the widget
				let widget = this.form.widgets.find(widget => widget.id == id);
				//set the new value for the widget
				widget.formControl.value = newValues[id];
			}
		},
		getInputWidth(id) {
			if (this.form.layout.width[id]) return this.form.layout.width[id];
			else return 12;
		},
		// Extract groups from the form data
		createWidgetGroups() {
			if (this.form.layout.groups == null) {
				this.ungroupedWidgets = this.form.widgets;
				return;
			}

			let widgetsSelected = [];
			this.form.layout.groups.forEach(group => {
				this.widgetGroups[group.id] = { ...group };
				this.widgetGroups[group.id].widgets = this.form.widgets.filter(x => group.widgetIds.includes(x.id));
				widgetsSelected = [...widgetsSelected, ...group.widgetIds];
			});

			this.ungroupedWidgets = this.form.widgets.filter(x => !widgetsSelected.includes(x.id));
		},
		// Apply the states, this function is run after every input, only validates the changed input
		applyStates(id) {
			if (!this.form.states || this.form.states.length === 0) return;
			if (!id) return;

			this.form.states.forEach(state => {
				let stateFulfilled = [];

				state.conditions.forEach((condition, i) => {
					if (condition[0] !== id) return;

					if (!condition[2]) {
						if (this.formValues[condition[0]] === condition[1]) {
							stateFulfilled.push(true);
						} else stateFulfilled.push(false);
					}

					if (condition[2]) {
						if (this.formValues[condition[0]] !== condition[1]) {
							stateFulfilled.push(true);
						} else stateFulfilled.push(false);
					}
				});

				if (!stateFulfilled.includes(false) && stateFulfilled.length !== 0) {
					this.states.visibility = { ...this.states.visibility, ...state.actions.visibility };
					this.formValues = {  ...this.formValues, ...state.actions.changeValue };
				}
			});
		},
		// If visibility is defined in data, return the value. Standard value is "null"
		checkVisibility(id) {
			if (this.states.visibility[id] !== undefined) return this.states.visibility[id];
			return true;
		},
		async validateValue(id) {
			if (!id) return;
			const url = `${this.baseUri}/validateControl`;
			const validateData = {
				"widgetId": id,
				"formValues": { ...this.formValues }
			};

			try {
				const result = await this.$post(url, validateData);
				let widget = this.form.widgets.find(x => x.id === id);
				widget.formControl = { ...widget.formControl, ...result[id] };

				// Do something
			} catch (error) {
				console.log(error);
			}
		}
	},
	created() {
		this.getForm();
	}
}, 'form/ak-form.html');